import { Component, OnInit, ViewChild } from '@angular/core';
import { WebsiteService } from 'src/services/websites.service';
import { NotificationService } from 'src/services/notification.service';
import { AppService } from 'src/app/app.service';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute } from '@angular/router';

declare var $;

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class WebsiteLogsComponent implements OnInit {
  public websiteLogs: any = [];
  public webUrlLogs: any = [];
  public websiteId = 0;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  public year: any = moment().format('YYYY');
  public filterLog: boolean = true;
  isSwitchActive: boolean;
  switchLabel: string = '';
  public websiteList: any = [];

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  constructor(
    private websiteService: WebsiteService,
    private noti: NotificationService,
    private appService: AppService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.appService.headerTitle.emit({ data: "www Monitor" });
    this.websiteId = this.route.snapshot.queryParams.id;
    if (!this.websiteId) {
      this.router.navigateByUrl('/www-monitor/list');
      return;
    }
    $('[data-toggle="tooltip"]').tooltip();
    this.getWebsiteLogs(this.websiteId);
    this.getwebsiteUrlLogs(this.websiteId);
    this.updateLabel();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  filterLogs(data) {
    if (data == "all") {
      this.filterLog = false;
      this.rerender();
    } else if (data == "default") {
      this.filterLog = true;
      this.rerender();
    }
  }

  getWebsiteLogs(Id) {
    this.websiteService.getWebsiteLog(Id).subscribe(response => {
      if (response.status === "ok") {
        this.websiteLogs = response.data;
      }
    }, error => {
      console.error('An error occurred:', error);
    });
  }

  getwebsiteUrlLogs(id) {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      dom: 'frtlip',
      order: [[0, 'desc']],
      destroy: true,
      columnDefs: [
        { width: "20%", targets: 0 },
        { width: "15%", targets: 1 },
        { width: "45%", targets: 2 },
        { width: "20%", targets: 3 },
      ]
    };
    this.websiteService.geturlLog(id).subscribe(response => {
      if (response.status == "ok") {
        if (response.data.length > 0) {
          this.webUrlLogs = response.data;
          this.isSwitchActive = this.websiteLogs.isActive === true;
          this.updateLabel();
          this.rerender();
        }
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  calculateDateDifference(startDate: string): string {
    const start = new Date(startDate);
    const end = new Date();
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();

    if (days < 0) {
      months--;
      days += this.daysInMonth(end.getMonth() - 1, end.getFullYear());
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    if (years === 0 && months === 0) {
      return `${days}d`;
    }

    let result = '';
    if (years > 0) result += `${years}y `;
    if (months > 0) result += `${months}m `;
    result += `${days}d`;

    return result.trim();
  }

  private daysInMonth(month: number, year: number): number {
    return new Date(year, month + 1, 0).getDate();
  }

  onSwitchToggle(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.isSwitchActive = isChecked;
    this.websiteService.checkStatus(this.websiteId).subscribe(response => {
      if (response.status === "ok") {
        this.updateLabel();
      }
    }, error => {
      if (error.status === 401) {
        console.error('Unauthorized access');
      }
    });
  }

  updateLabel(): void {
    this.switchLabel = this.isSwitchActive ? 'Active' : 'Inactive';
  }

  confirmDelete(id) {
    this.websiteId = id;
    $("#deleteModal").modal("show");
  }

  deleteWebsite() {
    this.websiteService.deleteWebsite(this.websiteId).subscribe(res => {
      if (res.status == "ok") {
        this.noti.notification("Success", "Website Deleted Successfully", "success");
        this.router.navigateByUrl('/www-monitor/list');
      } else {
        this.noti.notification("Error", "Cannot Delete This Website.", "danger");
      }
    }, error => {
      if (error.status == 401) { }
    });
    $("#deleteModal").modal("hide");
  }
}
